import { updateAdvertiser} from '@/api/advertiser'
import moment from 'moment';

export default {
    components: {
    },
    props: {
        showCreateEmailForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {
                // email: [ { required: true, message: '请填写邮箱', trigger: 'change' }],
            },
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        },
        // 快手：区分"绑定/修改快手邮箱"；其他媒体保持原文案
        title() {
            if (this.model && this.model.type === 'kuaishou') {
                return this.model.email ? '修改快手邮箱' : '绑定快手邮箱'
            }
            return '修改登录邮箱'
        }
    },
    mounted () {
        console.log('进入',this.model)
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true

            this.updateAdvertiser(this.model.id, this.model.email, this.model.field)
        },
        updateAdvertiser(id, value, field, refresh = true) {
            const update = ids => {
                const data = {
                    id: ids,
                    field: field,
                    value: value
                }
                updateAdvertiser(data, this.model.type).then(() => {
                    if (refresh) {
                        this.$message.destroy()
                        this.$message.success('操作成功')
                        this.close()
                    }
                }).catch(() => {
                    this.loading = false
                })
            }
            update([id])
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showCreateEmailForm', false)
            this.$emit('success')
        },
        moment,
    }
}
